import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Vue from 'vue'

const state = {
  // form
  serviceId: null,
  serviceContentsId: null,
  targetId: Constants.RegisterHash,

  // model
  layoutModel: null,
  serviceRssModel: [],
  serviceAttributeTypeModel: [],

  // form
  values: {
    screenNameSetting: {
      screenCode: null,
      screenName: null,
      screenConfigName: null,
    },
    isHomeScreen: false,
    screenSlideShowSettings: [],
    screenListBtnSettings: [],
    screenLabelSettings: [],
    screenImageSettings: [],
    screenBtnSettings: [],
  },

  // 元になる画面構成マスタのuuid
  screenConfigMstId: null,

  // validate
  // 各モジュールのバリデート結果
  validates: {
    slideshow: [],
    listButton: [],
    label: [],
    image: [],
    button: []
  },
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  },

  // バリデート結果(Boolean)を返す
  formIsValid: state => {
    let invalid = 0
    Object.keys(state.validates).forEach(key => {
      state.validates[key].forEach(item => {
        invalid += !item ? 1 : 0
      })
    })
    // console.log(invalid)
    return !invalid
  }
}

const actions = {
  /**
   * 初期読出し
   */
  loadModel ({commit}, {serviceId, serviceContentsId, targetId, screenSettingParams}) {
    commit('setServiceId', serviceId)
    commit('setServiceContentsId', serviceContentsId)
    commit('setTargetId', targetId)

    const serviceRssParams = {
      serviceUuid: serviceId
    }
    const serviceAttributeTypeParams = {
      serviceUuid:serviceId
    }

    return new Promise((resolve, reject) => {
      // 画面別コンテンツのjsonbを読出し
      ApiManager.request(
        [
          'serviceContentsSetting',
          'serviceRss',
          'serviceAttributeType'
        ],
        [
          'v1ServiceContentsScreenDetailGet',
          'v1ServiceRssListGet',
          'v1ServiceAttributeTypeListGet'
        ],
        [
          screenSettingParams,
          serviceRssParams,
          serviceAttributeTypeParams
        ])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            // サービスRSSリストを格納する
            commit('setServiceRssModel', res[1].data.serviceRssSettings)
            // 配信属性情報
            commit('setServiceAttributeTypeModel', res[2].data.serviceAttributeTypes)

            // APIレスポンスからscreenConfigMstUuidを取得
            let screenConfigLayoutParams = {
              screenConfigMstUuid: res[0].data.screenConfigMstUuid
            }

            // 画面構成マスタからレイアウト情報を読み出し
            ApiManager.request(
              ['screenConfigMst'],
              ['v1ScreenConfigMstLayoutGet'],
              [screenConfigLayoutParams])
              .then(layout => {
                let status = Utility.parseResponse(layout)

                if (status.result) {
                  commit('inited', {
                    layout: layout[0].data.screenConfigMst,
                    data: res[0].data
                  })
                  console.log('values', state.values)
                  console.log('layoutModel', state.layoutModel)

                  resolve()

                } else if (status.error) {
                  // エラーメッセージ表示
                  reject(res)
                } else {
                  // アプリケーションエラー表示
                  reject(null)
                }
              })
              .catch(error => {
                // アプリケーションエラー表示
                reject(null)
              })

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // init
  inited (state, {layout, data}) {
    // 画面構成マスタデータ
    if (layout.screenLayout !== undefined) {
      Vue.set(layout, 'screenLayout', JSON.parse(layout.screenLayout))
    }
    Vue.set(state, 'layoutModel', layout)

    // 画面構成マスタデータのuuid
    Vue.set(state, 'screenConfigMstId', data.screenConfigMstUuid)
    // 画面コードを生成
    // Vue.set(state.values.screenNameSetting, 'screenCode', Utility.generateUuid())
    Vue.set(state.values.screenNameSetting, 'screenCode', data.screenId)
    // 画面構成名
    Vue.set(state.values.screenNameSetting, 'screenConfigName', data.screenConfigName)

    // 1. 画面構成マスタデータからモジュールのコンテナを生成
    const config = state.layoutModel.screenLayout

    // スライドショー設定
    if (config.layoutSlideshow && config.layoutSlideshow.length) {
      config.layoutSlideshow.forEach((item, index) => {
        state.values.screenSlideShowSettings.push({
          // uuid: Jsonb.createUuid(['screen', 'slideshow'], index)
          uuid: item.uuid
        })
      })
    }
    // リストボタン（お知らせ/RSS）設定
    if (config.layoutList && config.layoutList.length) {
      config.layoutList.forEach((item, index) => {
        state.values.screenListBtnSettings.push({
          // uuid: Jsonb.createUuid(['screen', 'list'], index)
          uuid: item.uuid
        })
      })
    }
    // ラベル設定
    if (config.layoutLabel && config.layoutLabel.length) {
      config.layoutLabel.forEach((item, index) => {
        state.values.screenLabelSettings.push({
          // uuid: Jsonb.createUuid(['screen', 'label'], index)
          uuid: item.uuid
        })
      })
    }
    // イメージ設定
    if (config.layoutImage && config.layoutImage.length) {
      config.layoutImage.forEach((item, index) => {
        state.values.screenImageSettings.push({
          // uuid: Jsonb.createUuid(['screen', 'image'], index)
          uuid: item.uuid
        })
      })
    }
    // ボタン設定
    if (config.layoutButton && config.layoutButton.length) {
      config.layoutButton.forEach((item, index) => {
        state.values.screenBtnSettings.push({
          // uuid: Jsonb.createUuid(['screen', 'button'], index)
          uuid: item.uuid
        })
      })
    }

    // validate flag
    if (state.values.screenSlideShowSettings) {
      state.values.screenSlideShowSettings.forEach(item => state.validates.slideshow.push(false))
    }
    if (state.values.screenListBtnSettings) {
      state.values.screenListBtnSettings.forEach(item => state.validates.listButton.push(false))
    }
    if (state.values.screenLabelSettings) {
      state.values.screenLabelSettings.forEach(item => state.validates.label.push(false))
    }
    if (state.values.screenImageSettings) {
      state.values.screenImageSettings.forEach(item => state.validates.image.push(false))
    }
    if (state.values.screenBtnSettings) {
      state.values.screenBtnSettings.forEach(item => state.validates.button.push(false))
    }

    // 2. 登録した設定情報があれば反映
    // ※モジュールは画面構成マスタで登録されている数を優先する
    if (data.screenSettings !== null) {
      const model = data.screenSettings

      // 画面コード
      Vue.set(state.values.screenNameSetting, 'screenCode', model.screenNameSetting.screenCode)
      // 画面名
      Vue.set(state.values.screenNameSetting, 'screenName', model.screenNameSetting.screenName)
      // ホーム画面指定
      Vue.set(state.values, 'isHomeScreen', model.isHomeScreen)

      // スライドショー設定
      if (state.values.screenSlideShowSettings.length) {
        state.values.screenSlideShowSettings.forEach((item, index) => {
          if(model.screenSlideShowSettings && model.screenSlideShowSettings[index]) {
            Vue.set(state.values.screenSlideShowSettings, index, model.screenSlideShowSettings[index])
          }
        })
        // Vue.set(state.values, 'screenSlideShowSettings', model.screenSlideShowSettings)
      }
      // リストボタン（お知らせ/RSS）設定
      if (state.values.screenListBtnSettings.length) {
        state.values.screenListBtnSettings.forEach((item, index) => {
          if(model.screenListBtnSettings && model.screenListBtnSettings[index]) {
            Vue.set(state.values.screenListBtnSettings, index, model.screenListBtnSettings[index])
          }
        })
        // Vue.set(state.values, 'screenListBtnSettings', model.screenListBtnSettings)
      }
      // ラベル設定
      if (state.values.screenLabelSettings.length) {
        state.values.screenLabelSettings.forEach((item, index) => {
          if(model.screenLabelSettings && model.screenLabelSettings[index]) {
            Vue.set(state.values.screenLabelSettings, index, model.screenLabelSettings[index])
          }
        })
        // Vue.set(state.values, 'screenLabelSettings', model.screenLabelSettings)
      }
      // イメージ設定
      if (state.values.screenImageSettings.length) {
        state.values.screenImageSettings.forEach((item, index) => {
          if(model.screenImageSettings && model.screenImageSettings[index]) {
            Vue.set(state.values.screenImageSettings, index, model.screenImageSettings[index])
          }
        })
        // Vue.set(state.values, 'screenImageSettings', model.screenImageSettings)
      }
      // ボタン設定
      if (state.values.screenBtnSettings.length) {
        state.values.screenBtnSettings.forEach((item, index) => {
          if(model.screenBtnSettings && model.screenBtnSettings[index]) {
            Vue.set(state.values.screenBtnSettings, index, model.screenBtnSettings[index])
          }
        })
        // Vue.set(state.values, 'screenBtnSettings', model.screenBtnSettings)
      }
    }
  },

  // form
  setServiceId (state, id) {
    state.serviceId = id
  },
  setServiceContentsId (state, id) {
    state.serviceContentsId = id
  },
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // model
  setServiceRssModel (state, data) {
    Vue.set(state, 'serviceRssModel', data)
  },
  setServiceAttributeTypeModel(state, data) {
    Vue.set(state, 'serviceAttributeTypeModel', data)
  },

  // validate
  setValidate (state, {key, index, value}) {
    Vue.set(state.validates[key], index, value)
  },

  // form mode
  initModify (state, data) {
    Vue.set(state, 'values', data)
  },

  // reset
  reset (state) {
    state.serviceId = Constants.RegisterHash
    state.serviceContentsId = Constants.RegisterHash
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {
      screenNameSetting: {
        screenCode: null,
        screenName: null,
        screenConfigName: null,
      },
      isHomeScreen: false,
      screenSlideShowSettings: [],
      screenListBtnSettings: [],
      screenLabelSettings: [],
      screenImageSettings: [],
      screenBtnSettings: [],
    })
    Object.keys(state.validates).forEach(key => {
      Vue.set(state.validates, key, [])
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
